// @flow

const notificationsManagerState = {
  isEmailChannelCaptureOpen: false,
  isWebPushChannelCaptureOpen: false,
};

export default notificationsManagerState;



// WEBPACK FOOTER //
// ./app/NotificationsManager/settings/initialState.js